













































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import TextAreaComponent from "@/components/pages/notifications/TextAreaComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import SuccessBarComponent from "@/components/common/parts/SuccessBarComponent.vue";
import ErrorBarComponent from "@/components/common/parts/ErrorBarComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getRoutePath } from "@/router/routes";
import { postNoticeApi } from "@/typescript/api_client/emesh_api/notifications/notice_api";
import { checkValidation } from "@/typescript/lib/common/check_validation";

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    FormBoxComponent,
    InputTextComponent,
    TextAreaComponent,
    ButtonComponent,
    SuccessBarComponent,
    ErrorBarComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class NotificationsCreatePage extends Vue {
  title: string = "";
  content: string = "";
  isSuccess: boolean = false;
  errorMsg: string = "";
  isConfirmDialogOpen: boolean = false;

  get internalTitle() {
    return this.title;
  }

  get internalContent() {
    return this.content;
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(getRoutePath("DashboardPage"));
  }

  onClick() {
    this.hideErrorMsg();
    this.hideSuccessMsg();

    const validation = checkValidation([
      {
        condition: this.title.length > 30,
        errorMsg: "タイトルは30文字以内で入力してください"
      },
      {
        condition: this.content.length > 100,
        errorMsg: "本文は100文字以内で入力してください"
      }
    ]);

    if (validation.length) {
      this.errorMsg = validation[0].errorMsg;
      return;
    }

    postNoticeApi(this.title, this.content)
      .then(() => {
        this.isSuccess = true;
        this.title = "";
        this.content = "";
      })
      .catch(() => {
        this.errorMsg = "お知らせ登録に失敗しました";
      });
  }

  hideSuccessMsg() {
    if (this.isSuccess) this.isSuccess = false;
  }

  hideErrorMsg() {
    if (this.errorMsg) this.errorMsg = "";
  }

  setValue(key: string, value: string) {
    this[key] = value;
  }
}
